import styled from "styled-components";

export const CheckboxButtonStyles = styled.div`
  .checkboxButton {
    background: transparent;
    border: 1px solid ${({ theme }) => theme.colors.semantic.outline.default};
    border-radius: ${({ theme }) => theme.radius[4]};
    padding: ${({ theme }) => theme.spacing[4]} ${({ theme }) => theme.spacing[12]};
    font-style: normal;
    font-weight: ${({ theme }) => theme.typography.body.b2.weight};
    font-size: ${({ theme }) => theme.typography.body.b2.size};
    line-height: ${({ theme }) => theme.typography.body.b2.lineHeight};
    color: ${({ theme }) => theme.colors.semantic.text.weak};
    cursor: pointer;
  }

  .active {
    background: ${({ theme }) => theme.colors.primary[100]};
    border: 1px solid ${({ theme }) => theme.colors.semantic.text.strong};
    color: ${({ theme }) => theme.colors.semantic.text.strong};
  }
`;
